<template>
  <span class="df-logs">
    <!-- SETA O BOTÃO PARA ABRIR O LOG  -->
    <App-Button :cpntStatus="statusGeral" v-if="mostrarBT === true" @onClick="() => { dfLogsSetarMostrarTab(true) }" :cpntDisabled="disabledBT">
      <template v-if="statusGeral === ''">
        <template v-if="cpntDfLogTipo === 'comunicacao'">
          <!-- SETA O NOME DO STATUS -->
          <b style="color: #000; font-size: var(--font-base-soma-10);" v-html="dados.status_nome"></b>

          <!-- VERIFICA SE TEM ALGUM LOG -->
          <template v-if="[ '', null, undefined ].indexOf(dados.SitCodigo_log) === -1 && [ '', null, undefined ].indexOf(dados.SitCodigo_log[0]) === -1">
            <!-- FAZ A QUEBRA DE LINHA -->
            <br/>

            <!-- SETA OS STATUS DO CAMPO -->
            <span v-if="[ '', null, undefined ].indexOf(dados.SitCodigo_log[0].status) === -1" v-html="dados.SitCodigo_log[0].status"></span>

            <!-- SETA O ESPAÇO ENTRE AS FRASES -->
            <span v-if="[ '', null, undefined ].indexOf(dados.SitCodigo_log[0].status) === -1 && [ '', null, undefined ].indexOf(dados.SitCodigo_log[0].resultado) === -1">&nbsp;</span>

            <!-- SETA OS RESULTADO DO CAMPO -->
            <span v-if="[ '', null, undefined ].indexOf(dados.SitCodigo_log[0].resultado) === -1" v-html="dados.SitCodigo_log[0].resultado"></span>
          </template>
        </template>
        <template v-else-if="cpntDfLogTipo === 'email'">
          <!-- SETA A INFORMAÇÃO QUE AINDA NÃO FOI ENVIADO POR E-MAIL -->
          <span v-if="[ '', null, undefined ].indexOf(dados) !== -1 || [ '', null, undefined ].indexOf(dados.email_json_log) !== -1 || dados.email_json_log.length === 0">
            Está {{ dados.DocModelo }} ainda não foi enviada por e-mail.
          </span>
          <span v-else>
            <!-- VERIFICA SE TEM ALGUM LOG -->
            <template v-if="[ '', null, undefined ].indexOf(dados.email_json_log) === -1 && [ '', null, undefined ].indexOf(dados.email_json_log[0]) === -1">
              <!-- SETA O RETORNO DA API PARA O ENVIO -->
              <span v-if="[ '', null, undefined ].indexOf(dados.email_json_log[0].retornoApi) === -1" v-html="dados.email_json_log[0].retornoApi"></span>

              <!-- FAZ A QUEBRA DE LINHA -->
              <br/>
            </template>

            <!-- SETA O RETORNO DA API PARA O ENVIO -->
            <span v-if="[ '', null, undefined ].indexOf(dados.email_last_at_ptbr) === -1" v-html="dados.email_last_at_ptbr"></span>
          </span>
        </template>
        <template v-else>
          <b style="color: red;">ERRO 500</b>
        </template>
      </template>
    </App-Button>

    <!-- SETA A DIALOG PARA OS DADOS DA TABELA -->
    <RF-Dialog v-if="mostrarTab === true"
    :cpntStatus='statusGeral'
    :cpntLargura='cpntDfLogTipo === "comunicacao" ? "750px" : "1100px"'
    :cpntOnFecharDialog='dfLogsFechar'>
    <template slot='titulo'>
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO PARA COMUNICAÇÃO -->
      <template v-if="cpntDfLogTipo === 'comunicacao'">
        Histórico do Doc. Fiscal {{ dados.DocModelo }} {{ dados.DocNumero }} s. {{ dados.DocSerie }} com status: {{ dados.SitCodigo }} - {{ dados.status_nome }}
      </template>

      <!-- SETA O TITULO PARA EMAIL -->
      <template v-else-if="cpntDfLogTipo === 'email'">
        Histórico de envio por e-mail da {{ dados.DocModelo }} {{ dados.DocNumero }} s. {{ dados.DocSerie }}
      </template>

      <!-- SETA A MENSAGEM DE ERRO -->
      <template v-else>
        <b style="color: red;">ERRO 500</b>
      </template>
    </template>

    <template slot='botoes'>
      <App-Button :cpntIcone="'fas fa-redo-alt'" @onClick="() => { dfLogsBuscarDados(dfLogsSetarDadosTabela) }"></App-Button>
    </template>

    <template slot='conteudo'>
      <App-Tabela class="df-logs-tab"
      :cpntColuna="colunas"
      :cpntLinha="linhas"
      ref="tabela">
      </App-Tabela>
    </template>
    </RF-Dialog>
  </span>
</template>

<style scoped>
  .df-logs > button {
    min-height: 67px;
    width: 100%;
    max-width: 100%;
    white-space: inherit;
    /* word-break: break-word; */
  }

</style>

<style>
  .df-logs-tab > tbody > tr > td.col_mensagem {
    text-align: left;
  }

  .df-logs-tab > tbody > tr > td.col_id {
    width: 60px;
  }
  .df-logs-tab > tbody > tr > td.col_data {
    width: 125px;
  }
  .df-logs-tab > tbody > tr > td.col_usuario {
    width: 70px;
  }
  .df-logs-tab > tbody > tr > td.col_resultado {
    text-align: left !important;
  }

  .df-logs-tab > tbody > tr > td.col_id {
    width: 60px;
  }
  .df-logs-tab > tbody > tr > td.col_remetente,
  .df-logs-tab > tbody > tr > td.col_destinatario,
  .df-logs-tab > tbody > tr > td.col_responderPara {
    max-width: 150px;
  }
  .df-logs-tab > tbody > tr > td.col_data {
    width: 125px;
  }
  .df-logs-tab > tbody > tr > td.col_mensagem {
    text-align: left !important;
  }

  .df-logs-tab > tbody > tr > td.col_id {
    width: 60px;
  }
  .df-logs-tab > tbody > tr > td.col_remetente,
  .df-logs-tab > tbody > tr > td.col_destinatario,
  .df-logs-tab > tbody > tr > td.col_responderPara,
  .df-logs-tab > tbody > tr > td.col_data,
  .df-logs-tab > tbody > tr > td.col_mensagem {
    word-break: break-word;
  }
</style>

<script>
export default {
  props: {
    cpntDfId: {
      required: true,
      type: Number
    },
    cpntDfLogTipo: {
      required: true,
      type: String
    },
    cpntDados: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntMostrarBT: {
      required: false,
      default: function () {
        return false
      }
    },
    cpntMostrarTab: {
      required: false,
      default: function () {
        return false
      }
    },

    cpntFecharFormulario: {
      required: false,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      mostrarBT: false,
      mostrarTab: false,
      disabledBT: false,
      dados: null,
      colunas: [],
      linhas: []
    }
  },
  mounted: function () {
    this.dfLogsIniciar()
  },
  methods: {
    dfLogsIniciar: function () {
      // SETA O STATUS DA TELA
      this.dfLogsSetarStatusGeral('carregando')

      // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS
      if ([ '', null, undefined ].indexOf(this.cpntDados) === -1) {
        this.dfLogsSetarDados(JSON.parse(JSON.stringify(this.cpntDados)), () => {          
          // VERIFICA SE DEVE MOSTRAR OU NÃO OS BOTOES
          this.dfLogsSetarMostrarBT()
          this.dfLogsSetarMostrarTab()

          // SETA O STATUS DA TELA
          this.dfLogsSetarStatusGeral('')
        })
      } else {
        this.dfLogsBuscarDados(() => {          
          // VERIFICA SE DEVE MOSTRAR OU NÃO OS BOTOES
          this.dfLogsSetarMostrarBT()
          this.dfLogsSetarMostrarTab()

          // SETA O STATUS DA TELA
          this.dfLogsSetarStatusGeral('')
        })
      }
    },
    dfLogsFechar: function () {
      // VERIFICA SE TEM BOTÃO
      if (this.mostrarBT === true) {
        this.dfLogsSetarMostrarTab(false)
      }

      // MANDA FECHAR A JANELA
      if (this.cpntFecharFormulario !== null) {
        this.cpntFecharFormulario()
      }
    },
    dfLogsSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    dfLogsSetarMostrarBT: function () {
      // VERIFICA SE DEVE MOSTRAR O BOTÃO
      this.mostrarBT = this.cpntMostrarBT === true

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    dfLogsSetarMostrarTab: function (mostrar = '') {
      // VERIFICA SE DEVE MOSTRAR O BOTÃO
      this.mostrarTab = mostrar === '' ? this.cpntMostrarTab === true : mostrar

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // VERIFICA SE SERÁ ABERTO A TABELA
      if (this.mostrarTab === true) {
        this.dfLogsSetarDadosTabela()
      }
    },
    dfLogsBuscarDados: function (callback = null) {
      // CRIA A FORMULARIO DE ENVIO DA API
      var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }
      
      // SETA OS CAMPOS QUE DEVE RETORNAR
      queryGet.field = { DocModelo: null, DocNumero: null, DocSerie: null, SitCodigo: null, SitCodigo_log: null, email_last_at: null, email_json_log: null }
      
      // SETA O WHERE QUE DEVE REALIZAR
      queryGet.where = { f: 'id', o: '=', v: this.cpntDfId }

      // FAZ A COMUNICAÇÃO COM A API
      this.$store.state.comunicaAPI('/df/get/', 'GET', queryGet, (retorno) => {
        if ([ '', null, undefined ].indexOf(retorno) !== -1 || [ '', null, undefined ].indexOf(retorno.data) !== -1 || [ '', null, undefined ].indexOf(retorno.data[0]) !== -1) {
          // APRESENTA A MENSAGEM DE ERRO
          this.$store.state.msgWarn('WEB [500]: Erro ao recuperar dados da nota fiscal informada.', 'danger')

          // FECHA A TELA ABERTA
          this.dfLogsFechar(false)
        } else {
          this.dfLogsSetarDados(retorno.data[0], callback)
        }
      }, this.dfLogsSetarStatusGeral)
    },
    dfLogsSetarDados: function (vetor, callback = null) {
      // IMPORTA A BIBLIOTECA DEPENDENTE
      var moment = require('moment')

      // CONVERTE OS VALORES EM JSON
      if ([ '', null, undefined ].indexOf(vetor.email_json_log) === -1) {
        vetor.email_json_log = JSON.parse(vetor.email_json_log)
      }

      // QUEBRA AS LINHAS DO LOG
      var linhas = JSON.parse(JSON.stringify(vetor.email_json_log))

      // LIMPA O VALOR DO CAMPO
      vetor.email_json_log = []

      // INICIA O VETOR COM A QUANTIDADE TOTAL DE REGISTROS
      var count = linhas.length

      // RODA O VETOR, CONVERTENDO AS CHAVES
      for (var key in linhas) {
        if ([ '', null, undefined ].indexOf(linhas[key].Responder_Para) === -1) {
          while ((linhas[key].Responder_Para.indexOf('<') > -1) || (linhas[key].Responder_Para.indexOf('>') > -1)) {
            linhas[key].Responder_Para = linhas[key].Responder_Para.replace('<', '|')
            linhas[key].Responder_Para = linhas[key].Responder_Para.replace('>', '')
          }
          linhas[key].Responder_Para = linhas[key].Responder_Para.replace('|', '<br/>')
        } else {
          linhas[key].Responder_Para = ''
        }

        // DESFAZ O BASE 64 DO CAMPO
        if ([ '', null, undefined].indexOf(linhas[key].Mensagem === -1)) {
          linhas[key].Mensagem = decodeURIComponent(Array.prototype.map.call(window.atob(linhas[key].Mensagem), function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2) }).join(''))
        }

        // SETA O RETORNO
        linhas[key].retornoApi = ''

        // VERIFICA SE TEVE ALGUM ERETORNO
        if ([ '', null, undefined ].indexOf(linhas[key].Retorno) === -1) {
          linhas[key].retornoApi = 'Retorno ' + linhas[key].Retorno.code + ' ' + linhas[key].Retorno.message
        }

        // ADICIONA A COLUNA AO VETOR
        vetor.email_json_log.push({ id: count, remetente: linhas[key].Remetente, destinatario: linhas[key].Destinatario, responderPara: linhas[key].Responder_Para, mensagem: linhas[key].Mensagem, data: linhas[key].Data_Hora, retornoApi: linhas[key].retornoApi })

        // FAZ A CONTAGEM DOS RETORNOS
        count--
      }

      // CONVERTE A DATA
      vetor.email_last_at_ptbr = moment(vetor.email_last_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')

      // QUEBRA AS LINHAS DO LOG
      linhas = JSON.parse(JSON.stringify(vetor.SitCodigo_log)).split('.pl.')

      // LIMPA O VALOR DO CAMPO
      vetor.SitCodigo_log = []

      // INICIA O VETOR COM A QUANTIDADE TOTAL DE REGISTROS
      count = linhas.length - 1

      // PROCESSA CADA LINHA
      for (var indexC in linhas) {
        // QUEBRA AS COLUNAS DO LOG
        var coluna = linhas[indexC].split('.pc.')

        // VERIFICA SE A COLUNA NÃO VAI FICAR EM BRANCO
        if (coluna[0] !== '') {
          // FORMATA A DATA RECEBIDA
          coluna[2] = moment.unix(coluna[2]).format('DD/MM/YYYY HH:mm:ss')

          // DESFAZ O BASE 64 DO CAMPO
          if ([ '', null, undefined].indexOf(coluna[3]) === -1) {
            coluna[3] = decodeURIComponent(Array.prototype.map.call(window.atob(coluna[3]), function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            }).join(''))
          }

          // PEGA O USAURIO QUE GEROU O REGISTRO
          var usuario = this.$store.state.usuarios.filter(item => item.id === coluna[1])

          // SETA O NOME DO USUARIO
          coluna[1] = usuario.length >= 1 ? usuario[0].usuario : "<span>WEB [500]: Erro ao identificar Usuário.</span>"

          // ADICIONA A COLUNA AO VETOR
          vetor.SitCodigo_log.push({ id: count, status: coluna[0], usuario: coluna[1], data: coluna[2], resultado: coluna[3] })
        }

        // FAZ A CONTAGEM DOS RETORNOS
        count--
      }

      // INICIA O NOME DO STATUS
      var status = this.$store.state.codRetSefaz.filter(item => item.tipo === vetor.DocModelo && item.ref === vetor.SitCodigo)

      // SETA O STATUS DA NOTA
      vetor.status_nome = (status.length === 1 ? status[0].nome : 'ERRO')

      // SETA OS DADOS RECEBIDOS
      this.dados = vetor

      // VERIFICA SE DEVE DESATIVAR O BOTÃO
      this.disabledBT = (this.cpntDfLogTipo === 'email' && ([ '', null, undefined ].indexOf(this.dados) !== -1 || [ '', null, undefined ].indexOf(this.dados.email_json_log) !== -1 || this.dados.email_json_log.length === 0))

      // SETA O STATUS DA TELA
      this.dfLogsSetarStatusGeral('')

      // EXECUTA O CALLBACK RECEBIDO
      if (callback !== null && typeof callback === 'function') {
        callback()
      }
    },
    dfLogsSetarDadosTabela: function () {
      // SETA O STATUS DA TELA
      this.dfLogsSetarStatusGeral('carregando')

      // INICIA A VARIAVEL
      var colunas = []
      var linhas = []

      // SETA AS COLUNAS QUE DEVEM SER APRESENTADAS
      switch (this.cpntDfLogTipo) {
        case 'comunicacao':
          // SETA AS COLUNAS QUE DEVE APRESENTAR
          colunas = [
            { mPer: 2, chave: 'id',         nome: 'Tentativa' },
            { mPer: 2, chave: 'data',       nome: 'Data' },
            { mPer: 2, chave: 'usuario',    nome: 'Usuário' },
            { mPer: 2, chave: 'resultado',  nome: 'Resultado' }
          ]

          // SETA AS LINHAS QUE DEVE APRESENTAR
          linhas = this.dados.SitCodigo_log
          break

        case 'email':
          // SETA AS COLUNAS QUE DEVE APRESENTAR
          colunas = [
            { mPer: 2, chave: 'id',             nome: 'Envio' },
            { mPer: 2, chave: 'remetente',      nome: 'Remetente' },
            { mPer: 2, chave: 'destinatario',   nome: 'Destinatário' },
            { mPer: 2, chave: 'responderPara',  nome: 'Responder Para' },
            { mPer: 2, chave: 'mensagem',       nome: 'Mensagem' },
            { mPer: 2, chave: 'retornoApi',     nome: 'Retorno' },
            { mPer: 2, chave: 'data',           nome: 'Data/Hora de envio' }
          ]

          // SETA AS LINHAS QUE DEVE APRESENTAR
          linhas = this.dados.email_json_log
          break
      }

      // SETA AS COLUNAS RECEBIDAS
      this.colunas = colunas

      // SETA AS LINHAS DA TABELA
      this.linhas = linhas

      // SETA O STATUS DA TELA
      this.dfLogsSetarStatusGeral('')
    }
  },
  watch: {
    cpntMostrarBT: function () {
      this.dfLogsSetarMostrarBT()
    },
    cpntMostrarTab: function () {
      this.dfLogsSetarMostrarTab()
    },
    cpntDados: function () {
      this.dfLogsSetarDados(JSON.parse(JSON.stringify(this.cpntDados)))
    }
  }
}
</script>
